import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type UpdateBettieSatisfactionBody = NonNullable<
  paths['/api/v1/chat_rooms/{chat_room_id}/feedbacks']['post']['requestBody']
>['content']['application/json'];

export type UpdateBettieSatisfactionResponse =
  paths['/api/v1/chat_rooms/{chat_room_id}/feedbacks']['post']['responses'][201]['content']['application/json']['chatRoomFeedback'];

export type ChatRoomDetailResponse =
  paths['/api/v1/chat_rooms/{id}']['get']['responses'][200]['content']['application/json']['chatRoom'];

export type CreateChatRoomBody = NonNullable<
  paths['/api/v1/chat_rooms']['post']['requestBody']
>['content']['application/json'];
export type CreateChatRoomResponse =
  paths['/api/v1/chat_rooms']['post']['responses'][200]['content']['application/json']['chatRoom'];

export async function updateBettieSatisfaction({
  body,
  chatRoomId
}: {
  body: UpdateBettieSatisfactionBody;
  chatRoomId: string;
}): Promise<UpdateBettieSatisfactionResponse> {
  const { data, error } = await client.POST('/api/v1/chat_rooms/{chat_room_id}/feedbacks', {
    headers: authHeaders(),
    params: {
      path: {
        chat_room_id: chatRoomId
      }
    },
    body
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when updating bettie satisfaction');
  return data.chatRoomFeedback;
}

export async function getChatRoomDetail(chatRoomId: string): Promise<ChatRoomDetailResponse> {
  const { data, error } = await client.GET('/api/v1/chat_rooms/{id}', {
    headers: authHeaders(),
    params: {
      path: {
        id: chatRoomId
      }
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting chat room detail');
  return data.chatRoom;
}

export async function createChatRoom(body: CreateChatRoomBody): Promise<CreateChatRoomResponse> {
  const { data, error } = await client.POST('/api/v1/chat_rooms', {
    headers: authHeaders(),
    body
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when creating chat room');
  return data.chatRoom;
}